import React, { useEffect } from 'react';
import { AuthProvider, ThemeProvider, ProjectsProvider, ReportsProvider, ManualsProvider } from './contexts';
import { useAuth, useTheme, useManuals, useProjects, useReports } from './contexts';
import { LoginScreen } from './components/auth/LoginScreen';
import { Sidebar } from './components/layout/Sidebar';
import { Header } from './components/layout/Header';
import { AdminPanel } from './components/admin/AdminPanel';
import { ReportsSection } from './components/reports/ReportsSection';
import { ManualContent } from './components/manuals/ManualContent';
import { ChangePasswordModal } from './components/auth/ChangePasswordModal';
import { UserManagementModal } from './components/admin/UserManagementModal';
import { AddManualModal } from './components/manuals/AddManualModal';
import { AddCategoryModal } from './components/manuals/AddCategoryModal';
import { DeleteConfirmationModal } from './components/common/DeleteConfirmationModal';

const AppContent = () => {
    const { isLoggedIn, currentUser } = useAuth();
    const { darkMode } = useTheme();
    const { activeCategory, activeManual, showAdminPanel } = useManuals();
    const { loadProjects } = useProjects();
    const { loadUserReports } = useReports();

    // Загружаем проекты и отчеты при успешном входе и при смене пользователя
    useEffect(() => {
        if (isLoggedIn && currentUser) {
            loadProjects();
            loadUserReports();
        }
    }, [isLoggedIn, currentUser, loadProjects, loadUserReports]);

    if (!isLoggedIn) return <LoginScreen />;

    return (
        <div className={`min-h-screen flex ${darkMode ? 'bg-gray-900 text-gray-200' : 'bg-gray-50 text-gray-900'}`}>
            <Sidebar />
            <div className="flex-1 flex flex-col min-w-0">
                <Header />
                {showAdminPanel && <AdminPanel />}
                <main className="flex-1 overflow-y-auto p-4 md:p-6">
                    <div className="max-w-4xl mx-auto">
                        {activeCategory === 'reports' && activeManual ? <ReportsSection /> : <ManualContent />}
                    </div>
                </main>
            </div>
            {/* Модальные окна */}
            <ChangePasswordModal />
            <UserManagementModal />
            <AddManualModal />
            <AddCategoryModal />
            <DeleteConfirmationModal />
        </div>
    );
};

export const App = () => (
    <ThemeProvider>
        <AuthProvider>
            <ProjectsProvider>
                <ReportsProvider>
                    <ManualsProvider>
                        <AppContent />
                    </ManualsProvider>
                </ReportsProvider>
            </ProjectsProvider>
        </AuthProvider>
    </ThemeProvider>
);